import { render, staticRenderFns } from "./SalesTypeListEdit.vue?vue&type=template&id=73b36116"
import script from "./SalesTypeListEdit.vue?vue&type=script&lang=js"
export * from "./SalesTypeListEdit.vue?vue&type=script&lang=js"
import style0 from "./SalesTypeListEdit.vue?vue&type=style&index=0&id=73b36116&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports